export default {
    instruction:
        '登録番号は、<0>自社情報の設定ページ</0>より登録もしくは変更できます。',
    subTitle:
        '登録番号が表示される書類の種類。この設定はMakeLeapsが提供する標準テンプレートのみに反映されます。',
    successMessage: '登録番号の表示が編集されました。',
    title: '登録番号の表示',
};
